import { Action, getModule, Module, Mutation, VuexModule } from 'vuex-module-decorators'
import store from '@/store'
import CacheStore from '@/store/cache-store'
import { UserDto2 } from '@/services/Connector'
import { userClient } from '@/services/ApiService'

@Module({ namespaced: true, name: 'UserModule', store, dynamic: true })
export class UserModule extends VuexModule {
  public token: string = ''
  public pinMenu: boolean = false
  public currentUser: UserDto2 = new UserDto2()

  public get isConnected (): boolean {
    return this.token !== ''
  }

  public get menuIsPinned (): boolean {
    return this.pinMenu
  }

  public get isEAITeamOrAdmin () {
    return this.currentUser.roleName === 'Admin' || this.currentUser.roleName === 'EAi Team'
  }

  public get userPermissions(): string[]{
    return this.currentUser?.permissions ?? []
  }

  @Mutation
  public updateToken (token: string): void {
    this.token = token
    CacheStore.setToSession(CacheStore.TOKEN, token)
  }

  @Mutation
  public updatePinMenu (isPinned: boolean): void {
    this.pinMenu = isPinned
    CacheStore.set(CacheStore.MENU_PINNED, isPinned)
  }

  @Mutation
  public updateUser (user: UserDto2) {
    this.currentUser = user
  }

  @Action
  public async loadUserInformation () {
    this.updatePinMenu(CacheStore.get(CacheStore.MENU_PINNED) || false)
    const user = await userClient.getCurrentUser()
    this.updateUser(user)
  }

  @Action
  public userHavePermission(permissionName: string): boolean {
    return this.userPermissions.includes(permissionName)
  }
}

export default getModule(UserModule)
